import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

var API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export var fetchPrivacy = createAsyncThunk(
  "privacy/fetchPrivacy",
  async function (language, thunkApi) {
    try {
      if (!API_BASE_URL) {
        throw new Error("REACT_APP_API_BASE_URL is not configured");
      }

      var response = await fetch(API_BASE_URL + "/privacy", {
        method: "GET",
        signal: thunkApi.signal,
        headers: {
          Accept: "application/json",
          "Accept-Language": language || "en",
        },
      });

      var contentType = response.headers.get("content-type");

      if (!contentType || contentType.indexOf("application/json") === -1) {
        var responseText = await response.text();

        console.error("Non-JSON response:", responseText);

        throw new Error(
          "The privacy endpoint returned HTML instead of JSON"
        );
      }

      var responseData = await response.json();

      if (!response.ok) {
        return thunkApi.rejectWithValue(
          responseData.message ||
            "Unable to retrieve privacy policy"
        );
      }

      return responseData.data;
    } catch (error) {
      return thunkApi.rejectWithValue(
        error.message || "Unable to connect to the server"
      );
    }
  }
);

var initialState = {
  privacy: null,
  loading: false,
  error: "",
};

var privacySlice = createSlice({
  name: "privacy",
  initialState: initialState,
  reducers: {},
  extraReducers: function (builder) {
    builder
      .addCase(fetchPrivacy.pending, function (state) {
        state.loading = true;
        state.error = "";
      })
      .addCase(fetchPrivacy.fulfilled, function (state, action) {
        state.loading = false;
        state.privacy = action.payload;
      })
      .addCase(fetchPrivacy.rejected, function (state, action) {
        state.loading = false;
        state.error =
          action.payload || "Unable to retrieve privacy policy";
      });
  },
});

export default privacySlice.reducer;